import React from 'react'
import about from '../assets/images/2.jpg'
import { Link } from 'react-router-dom'

export default function AboutTwo() {
  return (
    <>
    <div className="row align-items-center">
        <div className="col-lg-5 col-md-6 order-1 order-md-2">
            <div className="rounded shadow bg-soft-primary p-4 pb-0">
                <img src={about} className="img-fluid rounded-top shadow" alt=""/>
            </div>
        </div>

        <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0 order-md-1 order-2">
            <div className="section-title me-lg-5">
                <h4 className="title mb-3">Review and manage <br/> team salaries</h4>
                <p className="text-muted para-desc mb-0">Ensuring secure transactions and seamless financial experiences for our users globally.</p>
            
                <ul className="list-unstyled text-muted mb-0 mt-3">
                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Digital Marketing Solutions for Tomorrow</li>
                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Our Talented & Experienced Marketing Agency</li>
                    <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Create your own skin to match your brand</li>
                </ul>

                <div className="mt-4">
                    <Link to="/aboutus" className="btn btn-soft-primary">About Us <i className="mdi mdi-arrow-right align-middle"></i></Link>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}
